import { useState } from 'react'
import { isBrowser } from '@walltowall/helpers'

export const useClipboard = () => {
  const [clipboard] = useState(() => (isBrowser ? navigator.clipboard : {}))

  const write = async text => {
    try {
      return await clipboard.writeText(text)
    } catch {
      return false
    }
  }

  const read = async () => {
    try {
      return await clipboard.readText()
    } catch {
      return false
    }
  }

  return { write, read }
}
